import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { connect } from 'react-redux';
import memoizeOne from 'memoize-one';

import { getEpisodeReviews, getMoreEpisodeReviews } from '../../actions';
import { FETCH_REVIEWS_ERROR } from '../../actions/types';
import { secToDate, getIdFromUID, sortLastModifiedDate } from '../../lib/utils';

import EmptyState from '../Common/EmptyState';
import Review from './Review';
import PodcastHeader from '../Podcast/PodcastHeader';
import PodcastEpisode from '../Podcast/PodcastEpisode';
import EpisodeSkeleton from '../Podcast/EpisodeSkeleton';
import InfiniteScroll from 'react-infinite-scroll-component';

import { HeartFilled, HeartOutlined } from '@ant-design/icons';

import { Affix } from 'antd';
import { spacing, colors, topBar, maxScreenSize } from '../../lib/theme';
import AppAlertDiv from '../Common/AppAlertDiv';

const ratingOptions = [5, 4, 3, 2, 1];
class ReviewList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterType: 'rating5', hasMore: { 'rating5': true, 'rating4': true, 'rating3': true, 'rating2': true, 'rating1': true }
        }
    }

    componentDidMount() {
        const { userDetails } = this.props;
        if (userDetails && typeof userDetails.uid !== 'undefined') {
            this.setPageData(userDetails);
        }
    }

    componentDidUpdate(prevProps) {
        const { userDetails } = this.props;
        if (prevProps && (typeof userDetails !== 'undefined' && userDetails !== prevProps.userDetails)) {
            this.setPageData(userDetails);
        }
    }

    setPageData = (userDetails) => {
        if (userDetails && userDetails.uid) {
            // this.setState({ loadingFavorites: true });
            let ratingFilter;
            if (this.state.filterType.includes('rating')) {
                ratingFilter = parseInt(this.state.filterType.replace('rating', ''));
            } else {
                ratingFilter = 5;
            }
            this.props.getEpisodeReviews(userDetails.uid, ratingFilter);
        }
    }

    showFilteredReviews = memoizeOne((filterType, uid, reviewsState) => {
        // const { userDetails, reviewsState } = this.props;
        let ratingFilter;
        if (filterType.includes('rating')) {
            ratingFilter = parseInt(filterType.replace('rating', ''));
        }
        const filteredReviews = [];
        for (let review of Object.values(reviewsState)) {
            if (review.user.id === getIdFromUID(uid)) {
                if (ratingFilter && ratingFilter > 0 && review.rating == ratingFilter) {
                    console.log('ratingFilter in : ' + ratingFilter);
                    filteredReviews.push(review);
                }
            }
        }
        return filteredReviews;
    });

    handleFilterChange = (value) => {
        this.setState({ filterType: value });
        const { userDetails, reviewsState } = this.props;
        // const favoriteEpisodes = this.showFilteredReviews(value, userDetails.uid, reviewsState);
        // if (favoriteEpisodes.length < 1) {
        let ratingFilter;
        if (value.includes('rating')) {
            ratingFilter = parseInt(value.replace('rating', ''));
        } else {
            ratingFilter = 5;
        }
        this.props.getEpisodeReviews(userDetails.uid, ratingFilter);
        // }
        // this.setState({ filterType: value });
    }

    fetchNextReviews = () => {
        const { filterType } = this.state;
        const { userDetails } = this.props;
        let ratingFilter;
        if (filterType.includes('rating')) {
            ratingFilter = parseInt(filterType.replace('rating', ''));
        } else {
            ratingFilter = 5;
        }
        this.props.getMoreEpisodeReviews(userDetails.uid, ratingFilter);
    }


    render() {
        const { userDetails, reviewsState, settingsState } = this.props;
        const { FETCH_REVIEWS_ERROR } = this.props.fetchError;
        const fetchError = FETCH_REVIEWS_ERROR;
        console.dir(reviewsState);
        console.dir(fetchError);
        const { loadingReviews, loadingUserDetails } = this.props.loadingState;
        const { filterType, hasMore } = this.state;

        let ratingFilter;
        if (filterType.includes('rating')) {
            ratingFilter = parseInt(filterType.replace('rating', ''));
        } else {
            ratingFilter = 5;
        }
        // let userId = userDetails && userDetails.uid && getIdFromUID(userDetails.uid);
        // let reviews = reviewsState[userId] || {};
        // const favoriteEpisodes = Object.values(reviews);
        // const fetchError = this.props.fetchError;
        const reviews = userDetails && this.showFilteredReviews(filterType, userDetails.uid, reviewsState);
        console.dir(reviews);
        return (
            <div>
                <Affix offsetTop={settingsState.topBar} style={{ textAlign: 'right' }}>
                    {!loadingUserDetails && userDetails && <div className='rating-filter'>
                        <p className='mb-0'><b>Filter by</b> &nbsp;</p>
                        <div style={{ display: 'flex', marginLeft: '1em' }}>
                            {ratingOptions.map((option) => (
                                <div key={option} onClick={this.handleFilterChange.bind(this, 'rating' + option)}
                                    className={`rating-option ${option == ratingFilter && 'rating-filled'}`}><p className='mb-0'>{option} <HeartOutlined style={{}} /></p></div>
                            ))}
                        </div>
                    </div>}
                </Affix>
                {/* {userDetails && loadingReviews && <p>Loading episodes&hellip;</p>} */}
                {userDetails && loadingReviews && <EpisodeSkeleton />}
                {/* {userDetails && !loadingReviews && reviews.length > 0 && <PodcastHeader />} */}
                {reviews &&
                    <InfiniteScroll
                        dataLength={reviews.length} //This is important field to render the next data
                        next={this.fetchNextReviews}
                        scrollThreshold={0.8}
                        hasMore={hasMore}
                    // loader={<EpisodeSkeleton />} // dont un-comment not sure when to show this
                    >
                        {
                            userDetails && reviews && reviews.sort(sortLastModifiedDate).map((review) => (
                                // <div key={review.episode.guid}>
                                //     <PodcastEpisode parent='personalReview' podcastEpisode={review.episode} />
                                // </div>
                                <Review key={review.episode.guid} review={review} type='personalReview' showPrivacyType={true} showEpisode={true} />
                            ))
                        }
                    </InfiniteScroll>
                }
                {
                    userDetails && !loadingReviews && !fetchError && reviews && !reviews.length &&
                    <div>
                        <EmptyState message="No favourites with this rating yet. Add to your favourites by clicking ♡ icon on any podcast episode."
                            subMessage="Sort your favourites by rating to keep track of them in future."
                            imageName="empty" />
                        {ratingFilter < 3 && <h5 style={{ textAlign: 'center', transform: 'translate(0, -2em)' }}>
                            Giving a lower rating is also useful if you don&apos;t want to listen to the episode in future.</h5>}
                    </div>
                }
                {reviews && !loadingReviews &&
                    <AppAlertDiv message={`Change 'Filter By' at top-right to see your other favorites.`} showIcon />
                    // <Alert style={{ marginTop: `${spacing()}` }} className='alert' message="Change 'Filter By' at top-right to see your other favorites." type="info" showIcon />
                }

                {!loadingReviews && fetchError && <AppAlertDiv style={{ marginTop: `${spacing()}` }} message='There was an error fetching ratings. Please try again.' type='error' />}
                <style jsx>
                    {`
                    .rating-filter{
                        // width: 35%;
                        // margin-left: 60%;
                        margin-bottom: ${spacing()};
                        // text-align: 'right';
                        padding: ${spacing()} 4em;
                        background: ${settingsState.cardColor}; // white;
                        box-shadow: 0 4px 4px -2px rgba(0,0,0,.2); 
                        display: inline-flex;
                        align-items: center;
                    }
                    .rating-option {
                        border: 1px solid ${colors.third};
                        padding: 2px 8px;
                        margin-right: 8px;
                        border-radius: 8px;
                        cursor: pointer;
                    }
                    .rating-filled {
                        background: ${colors.third};
                        color: white;
                    }
                    .rating-filled p {
                        color: white;
                    }
                    @media ${maxScreenSize.laptop} {
                        .rating-filter{
                            // width: 45%;
                            // margin-left: 50%;
                            padding: ${spacing()} 1em;
                        }
                    }
                `}
                </style>
            </div>
        );
    }

}

ReviewList.propTypes = {
    userDetails: PropTypes.object,
    reviewsState: PropTypes.object,
    loadingState: PropTypes.object,
    fetchError: PropTypes.object,
    settingsState: PropTypes.object,
    getEpisodeReviews: PropTypes.func,
    getMoreEpisodeReviews: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        loadingState: state.loadingState,
        reviewsState: state.reviewsState,
        settingsState: state.settingsState,
        fetchError: state.errorsState,
    }
}

// export default withRedux(initStore, null, null)(Personal)
const mapDispatchToProps = (dispatch) => {
    return {
        // setUserDetails: bindActionCreators(setUserDetails, dispatch),
        getEpisodeReviews: bindActionCreators(getEpisodeReviews, dispatch),
        getMoreEpisodeReviews: bindActionCreators(getMoreEpisodeReviews, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewList);
